import { useCallback, useEffect, useContext, memo } from 'react'

import { TtsItemContext } from 'containers/SubSidebar/TtsContent/List/Item/contextApi'
import { TtsItemSpeakerFlyoutContext } from 'containers/SubSidebar/TtsContent/List/Item/SpeakerFlyout/contextApi'
import { TTS_LANGUAGE_ITEM_CLASS_NAME } from '../../../consts'
import LanguageDropdown from 'containers/SubSidebar/shared/Voices/LanguageDropdown'
import { useSelector } from 'react-redux'
import { voiceCatalogThunks } from 'store/features/voiceCatalog/thunks'
import { voiceCatalogSelectors } from 'store/features/voiceCatalog/selectors'
import { dispatch } from 'store'

const TtsItemLanguageDropdown: React.FC = () => {
  const { ttsItemLangCode, handleLanguageChange, handleVoiceChange } =
    useContext(TtsItemSpeakerFlyoutContext)

  const { scrollableParentRef } = useContext(TtsItemContext)
  const ttsLangOptions = useSelector(voiceCatalogSelectors.languageOptionsData)
  const isLanguageOptionsLoading = useSelector(
    voiceCatalogSelectors.isLanguageOptionsLoading
  )

  const handleTtsLanguageClick = useCallback(
    (langCode: string | number) => {
      if (langCode === ttsItemLangCode) return

      handleLanguageChange(langCode as string)
      dispatch(
        voiceCatalogThunks.getSpeakersPerLangCode(
          langCode as string,
          speakerId => {
            handleVoiceChange(speakerId)
          }
        )
      )
    },
    [ttsItemLangCode, handleLanguageChange, handleVoiceChange]
  )

  useEffect(() => {
    if (!ttsLangOptions?.length) {
      dispatch(voiceCatalogThunks.getLanguageOptions())
      dispatch(voiceCatalogThunks.getSpeakersPerLangCode(ttsItemLangCode))
    }
  }, [ttsLangOptions, isLanguageOptionsLoading, ttsItemLangCode])

  return (
    <LanguageDropdown
      languageOptions={ttsLangOptions}
      selectedLanguageId={ttsItemLangCode}
      isDataLoading={isLanguageOptionsLoading}
      onLanguageChange={handleTtsLanguageClick}
      scrollableParentRef={scrollableParentRef}
      childClassName={TTS_LANGUAGE_ITEM_CLASS_NAME}
    />
  )
}

export default memo(TtsItemLanguageDropdown)
